import React, { Component } from 'react';
import { connect } from 'react-redux';

import GoogleMap from './GoogleMap.jsx';

class GoogleMapHOC extends Component {
    state = {
        shouldRender: false
    }

    componentDidMount() {
        setTimeout(() => {
            this.setState({ shouldRender: true });
        }, 0);
    }

    render() {
        if (this.state.shouldRender) {
            return (
                <GoogleMap
                    containerElement={
                        <div
                            style={{
                                height: '100%'
                            }}
                            role="presentation"
                            aria-hidden="true"
                        />
                    }
                    mapElement={
                        <div
                            style={{
                                width: '100%',
                                height: '100%'
                            }}
                        />
                    }
                />
            );
        }
        return null;
    }
}

const mapStateToProps = state => ({
    contentLoading: state.contentLoading,
    initialContentLoaded: state.initialContentLoaded,
    unstable: state.mapState.unstable
});

export default connect(mapStateToProps)(GoogleMapHOC);



// WEBPACK FOOTER //
// ./src/pages/Search/Main/MapSection/GoogleMap/GoogleMapHOC.jsx